import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DownloadIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    maxWidth: '900px',
    width: '100%',
  },
  dialogContent: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '500px',
    backgroundColor: '#f5f5f5',
  },
  iframe: {
    width: '100%',
    height: '600px',
    border: 'none',
    borderRadius: theme.spacing(0.5),
  },
  loader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  headerActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

interface PDFPreviewModalProps {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
  fileName?: string;
}

export const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({
  open,
  onClose,
  pdfUrl,
  fileName = 'Document',
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        <Box className={classes.headerActions}>
          <Typography variant="h6" className={classes.title}>
            {fileName}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            style={{ marginLeft: 'auto' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {isLoading && (
          <Box className={classes.loader}>
            <CircularProgress />
            <Typography variant="caption">Loading PDF...</Typography>
          </Box>
        )}
        <iframe
          src={`${pdfUrl}#toolbar=1`}
          title={fileName}
          className={classes.iframe}
          onLoad={() => setIsLoading(false)}
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<DownloadIcon />}
          onClick={handleDownload}
          color="primary"
        >
          Download
        </Button>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDFPreviewModal;
